import { Pipe, type PipeTransform } from '@angular/core';
import { CmsComponent, CX_COMPONENT } from '@app/core/models/atomics.model';

@Pipe({
  name: 'cmsComponent',
})
export class CmsComponentPipe implements PipeTransform {
  transform(components: CmsComponent[], type: CX_COMPONENT): CmsComponent {
    return components.find(c => c.type === type)!;
  }
}
